// @ts-ignore

import { css } from "@compiled/react";

import { RichTextComponent } from "@/libraries/design/utils";

import { TextContent as TextContentData } from "./types.ts";

export interface TextContentProps {
    data: TextContentData;
}

export const TextContent = (props: TextContentProps) => {
    const { data } = props;

    if (data.type === "plaintext") {
        return <span css={textCss}>{data.value}</span>;
    }
    if (data.type === "richtext") {
        return (
            <span css={textCss}>
                <RichTextComponent text={data.value} />
            </span>
        );
    }

    throw new Error(`unknown text-content type: ${data.type}`);
};

const textCss = css({
    "textAlign": "start",
    "fontSize": "14px",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "& p": {
        fontSize: "14px"
    }
});
